module.exports = __webpack_public_path__ + "static/media/Moen.8e09da4c.svg";